import {useState} from 'react';
import {Button} from '../primitives/button';
import {Icons} from '../icons';
import {copyMarkdownToClipboard} from '../lib/clipboard';

export type CopyButtonProps = {
  content: string;
  onCopy?: () => Promise<void>;
  onTooltipOpenChange?: (open: boolean) => void;
};

export const CopyButton = ({
  content,
  onCopy,
  onTooltipOpenChange,
}: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await (onCopy ? onCopy() : copyMarkdownToClipboard(content));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard write unavailable (e.g. permissions denied)
    }
  };

  return (
    <Button
      size="icon"
      className="size-6 min-h-6 min-w-6 text-muted-foreground"
      variant="ghost"
      onClick={handleCopy}
      tooltip={copied ? 'Copied' : 'Copy'}
      onTooltipOpenChange={onTooltipOpenChange}
    >
      {copied ? (
        <Icons.check className="size-4" />
      ) : (
        <Icons.copy className="size-4" />
      )}
    </Button>
  );
};
